window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');

require('bootstrap-sass');

require('jquery-freeze-table/dist/js/freeze-table.min');

require('./plugins/jquery.fixedheadertable.min');
require('./plugins/defaultTheme.css');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.Chart = require('../../../node_modules/chart.js/dist/Chart.bundle.min.js');


/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

require('../../../node_modules/timepicker/jquery.timepicker.min');
require('../../../node_modules/bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min');
require('../../../node_modules/select2/dist/js/select2.full.min');
require('../../../node_modules/tablesorter/dist/js/jquery.tablesorter.js');
require('../../../node_modules/datatables.net-bs/js/dataTables.bootstrap.min');
require('../../../node_modules/tinymce/tinymce.min');
require('./plugins/tinymce/placeholder.min');
require('./tinymce/langs/de');

window.scrollbooster = require('scrollbooster');

window.datepicker = require('bootstrap-datepicker');
require('../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.de');

window.Cookies = require('js-cookie');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
